import { PropTypes, css, styled } from '../lib/imports';

const baseStyles = () => css`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
`;

const marginStyles = ({ theme, hasMargin }) =>
  hasMargin &&
  css`
    margin-bottom: ${theme.spacings.giga};
  `;

const alignStyles = ({ alignTop }) =>
  alignTop &&
  css`
    align-items: flex-start;
  `;

const Row = styled('div')(baseStyles, marginStyles, alignStyles);

Row.propTypes = {
  children: PropTypes.node,
};

export default Row;
